import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { defaultCTAURI } from 'src/modules/utils/constants'
import { ratePlanCodes } from 'src/constants/ratePlanCode'
import { selectCTAParams } from 'src/modules/reducers/params'
import { createUrl } from 'src/modules/utils/createUrl'
import { replaceUrlParam } from 'src/modules/utils/replaceUrlParam'
import { useSelector } from 'react-redux'
import { fireUIInteractionEvent, fireUIRenderEvent } from 'src/modules/analytics/v3'
import { selectStateForProtobuf } from 'src/modules/reducers'
import { useCtaText } from 'src/modules/hooks/useCtaText'
import { colors } from 'src/constants/marketing-ds/colors'
import CTAButton from '../CTAButtonNew'
import { BannerHeader } from '../SharedComponents'
import { mediaQuery, spacing } from 'src/constants/marketing-ds'
import { selectAnalyticsReady } from 'src/modules/reducers/analytics'

const RedzoneBanner = ({
  title,
  redzoneOfferCode,
  ctaText,
  disableFreeTrial,
  redzoneAddOnCode,
}) => {
  const parsedParams = useSelector(selectCTAParams)
  const stateForProtobuf = useSelector(selectStateForProtobuf)
  const isAnalyticsReady = useSelector(selectAnalyticsReady)
  const isEventSent = useRef(false)

  let ctaURL = createUrl(defaultCTAURI, parsedParams)
  ctaURL = replaceUrlParam(ctaURL, 'offer', redzoneOfferCode || ratePlanCodes.elite)
  ctaURL = replaceUrlParam(ctaURL, 'comp', 'redzone')
  if (redzoneAddOnCode) {
    ctaURL = replaceUrlParam(ctaURL, 'addons[]', redzoneAddOnCode)
  }
  const handleOnClick = (e) => {
    fireUIInteractionEvent(
      {
        element: 'Choose the Elite with Sports Plus plan to watch',
        component: 'redzone_promo_banner_cta_clicked',
        type: 'clicked',
      },
      stateForProtobuf
    )
  }

  const defaultTitle = (
    <>
      Choose{' '}
      <a href={ctaURL} className="highlight">
        Elite with Sports Plus
      </a>{' '}
      to watch
    </>
  )

  const ctaCopy = useCtaText({
    lang: 'en',
    market: 'us',
    disableFreeTrial,
    isTextShort: true,
    ctaText,
  })

  // init location check and set RSN eligibility
  useEffect(() => {
    if (!isEventSent.current && isAnalyticsReady) {
      fireUIRenderEvent(
        {
          component: 'redzone_promo_banner',
        },
        stateForProtobuf
      )
      isEventSent.current = true
    }
  }, [isAnalyticsReady])

  return (
    <StyledRedzoneBanner>
      <div className="banner-content">
        <div className="banner-text">
          <BannerHeader title={title || defaultTitle} variant="light" />
        </div>
        <div className="banner-logos">
          <span className="banner-image redzone">
            <img
              src="https://assets-imgx.fubo.tv/marketing/lp/images/networks/logo-nfl-redzone-slim.png"
              alt=""
              width="100%"
            />
          </span>
        </div>
        <CTAButton link={ctaURL} onClick={handleOnClick} isOutlined={true}>
          {ctaCopy}
        </CTAButton>
      </div>
    </StyledRedzoneBanner>
  )
}

export default RedzoneBanner

const StyledRedzoneBanner = styled.div`
  background: ${colors.slate[30]};
  width: 100%;
  z-index: 5;
  text-align: left;
  .banner-content {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    gap: ${spacing.md};
    padding: ${spacing.lg} ${spacing.xs};
    flex-direction: column;

    ${mediaQuery.tabletMax} {
      flex-direction: row;
    }

    .banner-logos {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 7%;
      max-width: 240px;

      .banner-image {
        &.redzone {
          flex: 1 1 60%;
        }
        &.showtime {
          flex: 1 1 40%;
        }
      }
      width: 75%;
      max-width: 200px;
      gap: 20px;

      ${mediaQuery.tabletMax} {
        flex: 0 1 330px;
      }
    }
    .banner-text {
      color: #fff;
      flex: 0 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      span.block {
        display: inline-block;
      }
      h3 {
        .highlight {
          text-decoration: underline;
        }

        @media screen and (max-width: 768px) {
          display: flex;
          flex-direction: column;
          gap: 4px;
          justify-content: center;
        }
      }
      h4 {
        color: #fff;
      }
    }
  }
`
